import { render, staticRenderFns } from "./transportModel.vue?vue&type=template&id=7ec6697d&scoped=true"
import script from "./transportModel.vue?vue&type=script&lang=js"
export * from "./transportModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6697d",
  null
  
)

export default component.exports